import { IController } from 'angular';

export class MonitorAttendanceCtrl implements IController {
  static $inject = [];

  constructor() {
    //
  }

  $onInit() {
    //
  }
}
